module.exports = __webpack_public_path__ + "static/media/185.41449cd7.svg";